import { startsWith as _startsWith } from 'lodash';

import { AuthApi } from '../Authentication/Authentication'; // eslint-disable-line import/no-cycle
import { execute } from '../Daf'; // eslint-disable-line import/no-cycle

class DXL {
  constructor() {
    this.baseUrl = '';
    this.baseHeaders = {};
  }

  _getUrl = url => {
    return _startsWith(url, 'http') ? url : `${this.baseUrl}${url}`;
  };

  configure = (baseUrl, headers = {}) => {
    this.baseUrl = baseUrl;
    this.baseHeaders = headers;
  };

  authorize = (url, headers = {}, params = {}) => {
    const _url = this._getUrl(url);
    const _headers = { ...this.baseHeaders, ...headers };

    return AuthApi.authorize(_url, _headers, params);
  };

  request = (type, url, headers, options = {}, withAuth = true) => {
    const _url = this._getUrl(url);
    const _headers = { ...this.baseHeaders, ...headers };

    const requestObject = {
      type,
      url: _url,
      headers: _headers,
      ...options,
    };

    const requestFunction = withAuth ? AuthApi.request : execute;

    return requestFunction(requestObject);
  };
}

export { DXL };

export default new DXL();
